<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/XY5HHv/tc-custom/9781467450683.jpg?1728070171243" alt="This image is the cover for the book From Good News to Gospels"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">From Good News to Gospels
      </h1>
      <p class="bookDescription body article font2">
        <p>The good news of Jesus spread like wildfire through the Roman Empire in the decades between his death and the writing of the first gospels—but how? What exactly did the first Christians say about Jesus? In <i>From Good News to Gospels</i> David Wenham delves into the gospels, the book of Acts, and the writings of Paul to uncover evidence of a strong and substantial oral tradition in the early church. This book will inform, engage, and challenge readers, inspiring them to better understand and appreciate the earliest gospel message.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        David Wenham, Donald A. Hagner
      </h2>
      
      <p class="authorDescription body article"><BR /><B>David Wenham</B>&#160;is a well-known British theologian who has specialized in Christian origins during his teaching career at Wycliffe Hall, Oxford, and Trinity College, Bristol, among other places. His previous books include&#160;<I>The Parables of Jesus </I>and<I> Paul: Follower of Jesus or Founder of Christianity?</I></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      William B. Eerdmans Publishing Company
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?040b365a